import React from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
  Cancel as CancelIcon,
  PostAdd as PostAddIcon,
  Add as AddIcon,
  ViewList as ViewListIcon,
  ArrowBack as ArrowBackIcon,
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";

// provider
import { useLayout } from  "../../providers/App/Layout/LayoutProvider";

const structure = [
  {
    id: 0,
    label: "Cancellations",
    link: "/app/cancellations",
    icon: <CancelIcon />,
    children: [
      { label: "Create", icon: <AddIcon />,link: "/app/cancellations/create" },
      { label: "View All", icon: <ViewListIcon />, link: "/app/cancellations/view" },
    ],
  },
  {
      id: 1,
      label: "Bulk Cancellations",
      link: "/app/cancellations/bulkcancel",
      icon: <PostAddIcon />
  }
];

const Sidebar = ({ location }) => {
  // global
  const { sidebarState } = useLayout();

  const classes = useStyles();
  const theme = useTheme();


  // local
  const [isPermanent, setIsPermanent] = React.useState(true);

  const handleWindowWidthChange = () => {
    const windowWidth = window.innerWidth;
    const breakpointWidth = theme.breakpoints.values.md;
    const isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setIsPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setIsPermanent(true);
    }
  }

  React.useEffect(() => {
    window.addEventListener("orientationchange", handleWindowWidthChange);
    handleWindowWidthChange();
    return () => window.removeEventListener("orientationchange", handleWindowWidthChange);
  });

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: sidebarState.isSidebarOpened,
        [classes.drawerClose]: !sidebarState.isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: sidebarState.isSidebarOpened,
          [classes.drawerClose]: !sidebarState.isSidebarOpened,
        }),
      }}
      open={sidebarState.isSidebarOpened}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => sidebarState.setIsSidebarOpened(!sidebarState.isSidebarOpened)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <div className="text-align-center p-l-16 p-r-16 p-t-16 p-b-16">
        <img
          className="img-responsive"
          alt="6thStreet.com"
          src="/assets/images/Logo.png" />
      </div>
      <List className={classes.sidebarList}>
        {structure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={sidebarState.isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );
}

export default withRouter(Sidebar);
